// app.routes.ts
import { Routes } from "@angular/router";
import { HealthComponent } from "./components/shared/health/health.component";
import { ExternoTokenOidcComponent } from "./components/shared/externo-token-oidc/externo-token-oidc.component";
import { RdsTokenPingidComponent } from "./components/shared/rds-token-pingid/rds-token-pingid.component";
import { LoginSdkComponent } from "./components/shared/login-sdk/login-sdk.component";
// import { SourcesComponent } from "./pages/sources/sources.component";
// import { SourcesDetailsComponent } from "./pages/sources/sources-details/sources-details.component";

export const routes: Routes = [
  {
    path: '',
    // Nota: Si migras todo a Standalone, esto debería apuntar a unas rutas hijas
    // o a un componente standalone, no a un Modulo.
    // Sin embargo, Angular moderno aún soporta cargar Modulos así:
    loadChildren: () =>
      import("./layout/layout.module").then((m) => m.LayoutModule),
  },
  { path: 'callback', component: LoginSdkComponent },
  { path: 'management/health', component: HealthComponent },
  { path: 'externo/token', component: ExternoTokenOidcComponent },
  {
    path: 'interno/token/rds/:region/:domain/:subDomain/:primaryKey',
    component: RdsTokenPingidComponent
  },


  // {
  //   path: 'externo/source/:type/:region/:mode/:domain/:subDomain',
  //   component: SourcesComponent
  // },
  // {
  //   path: 'externo/source/:type/:region/:mode/:domain/:subDomain/:machkey',
  //   component: SourcesDetailsComponent
  // },
  //
  // {
  //   path: 'externo/source/:type/:region/:mode/:domain/:subDomain/:matchkey',
  //   component: SourcesDetailsComponent
  // },
];
